// src/main.js
import { createApp } from "vue";
import { createNaverMap } from "vue3-naver-maps";
import App from "./App.vue";
import router from "./router";

// FontAwesome 설정
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faPhone,
  faLocationDot,
  faAngleUp,
  faChevronDown,
  faChevronUp,
  faRightFromBracket
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

//게시판
import "@/assets/editor-custom.css";

// 사용할 아이콘 등록
library.add(faBars, faPhone, faLocationDot, faAngleUp, faChevronUp, faChevronDown, faRightFromBracket);

// 앱 생성 및 설정
const app = createApp(App);

// 글로벌 컴포넌트 등록
app.component("font-awesome-icon", FontAwesomeIcon);

// NaverMap 설정
app.use(createNaverMap, {
  clientId: process.env.VUE_APP_NAVER_MAP_API, // 본인의 클라이언트 아이디로 변경
  category: "ncp", // (선택 사항) 기본값은 ncp
  subModules: [], // 필요한 서브 모듈을 추가할 수 있음 (예: 'search', 'geocoder' 등)
});

// 라우터 등록
app.use(router);

// 마운트
app.mount("#app");
